export const NAVIGATION_ACTIONS = {
  FETCH_NAVIGATION: 'NAVIGATION/FETCH_NAVIGATION',
  FETCH_NAVIGATION_SUCCESS: 'NAVIGATION/FETCH_NAVIGATION_SUCCESS',
  FETCH_NAVIGATION_ERROR: 'NAVIGATION/FETCH_NAVIGATION_ERROR',
};
